<template>
  <v-card class="mx-auto" color="#primary" height="200px">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline">Atlanta</v-list-item-title>
          <v-list-item-subtitle>{{date}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-card-text>
      <v-layout align="center">
        <v-flex xs="6" display-3>
          {{temp}}
        </v-flex>
        <v-flex xs="6">
          <v-img
            src="http://cdn.vuetifyjs.com/images/cards/sun.png"
            alt="Sunny image"
            width="92"
          ></v-img>
        </v-flex>
      </v-layout>
    </v-card-text>

  </v-card>
</template>

<script>
  export default {
    data: () => ({

    }),
    methods: {
    },
    computed: {
      date(){
        let data = this.$store.state.skyspark.date;
        return data.toLocaleDateString(undefined,{weekday: 'short', hour: '2-digit', minute: '2-digit'})
      },
      temp(){
        return this.$store.state.skyspark.temp;
      },
    },
    mounted() {
    },
  }
</script>
